// extracted by mini-css-extract-plugin
export default {"text":"LoginSpinner_text__iHXt3"};